"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffsetConnectionSuccess = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const OffsetConnectionSuccess = ({ size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true },
    react_1.default.createElement("path", { fill: "#8EE43F", d: "M11,4.4L6.8,8.6 5,6.8 3.6,8.2 6.9,11.5 12.4,5.8 11,4.4zM8,1C11.9,1 15,4.1 15,8 15,11.9 11.9,15 8,15 4.1,15 1,11.9 1,8 1,4.1 4.1,1 8,1z" })));
exports.OffsetConnectionSuccess = OffsetConnectionSuccess;
//# sourceMappingURL=OffsetConnectionSuccess.js.map